import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=695a9a4e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('695a9a4e')) {
      api.createRecord('695a9a4e', component.options)
    } else {
      api.reload('695a9a4e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=695a9a4e&", function () {
      api.rerender('695a9a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/comp/IncreaseNumber.vue"
export default component.exports